export type YearlyNiyaazPaymentBreakdownRow = {
  mode: string;
  total: number;
  count: number;
};

/** Sum receipt-mode rows for the Payments by Mode table TOTAL. */
export function sumPaymentBreakdown(rows: readonly YearlyNiyaazPaymentBreakdownRow[]): {
  total: number;
  count: number;
} {
  return rows.reduce(
    (acc, row) => ({
      total: acc.total + (Number(row.total) || 0),
      count: acc.count + (Number(row.count) || 0),
    }),
    { total: 0, count: 0 }
  );
}
